//import axios from 'axios'

const state = {
  residenza:{
    nazione:{"CODICENU":null,"DECODIF":null},
    comune:{"CODICECOMUNE":null,"DECODIF":null},
    cap: null,
    telefono: null,
    indirizzo:null
  },
  recapito:{
    nazione:{"CODICENU":null,"DECODIF":null},
    comune:{"CODICECOMUNE":null,"DECODIF":null},
    cap: null,
    telefono: null,
    indirizzo:null,
    presso: null,
    cellulare: null
  },

};
const getters = {};
const actions = {
  async salvaDati({ commit }, payload) {
    await commit(payload.azione, payload.dati);
  },
  
  
};
const mutations = {
  setIscrizione: (state, dati) => {
    alert(JSON.stringify(dati));
    //state.riepilogo.iscrizione.facolta.val = dati.fac_scelta.CODICENU
    //state.riepilogo.iscrizione.facolta.desc = dati.fac_scelta.DECODIF
  },
  
};

export default {
  state,
  mutations,
  getters,
  actions,
};
